import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import rightArrow from "../../assets/SetaDireita.svg";
import styles from "./listaUsuarios.module.css";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import api from "../../utils/axios/api";
import SideBar from "../../components/SideBar/SideBar";
import UsuarioItemAdmin, {
  Usuariocard,
} from "../../components/CardUsuarioAdmin/CardUsuarioAdmin";
import SelectWithLabel from "../../components/SelectWithLabel";

function ListaUsers() {
  const [filterUser, setFilterUser] = useState<
    "Client" | "Entrepeneur" | "Admin" | "all"
  >("all");
  const [usuarios, setUsuarios] = useState<Usuariocard[]>([]);
  const [isMobileMenuVisible, setIsMobileMenuVisible] = useState<boolean>(true);
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(
    window.innerWidth < 768
  );

  function handleWindowSizeChange() {
    setIsSmallScreen(window.innerWidth < 768);
  }

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    // Executar uma vez no início para garantir que o estado é atualizado com a largura da janela atual
    handleWindowSizeChange();

    return () => window.removeEventListener("resize", handleWindowSizeChange);
  }, []);

  async function getUsers() {
    try {
      let response;
      if (filterUser === "all") {
        response = await api.get(`/admin/user`);
      } else {
        response = await api.get(`/admin/user?role=${filterUser}`);
      }
      setUsuarios(response.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    getUsers();
  }, [filterUser]);

  async function deleteUser(userId: string) {
    try {
      await api.delete(`/admin/user/${userId}`);
      getUsers();
    } catch (error) {
      alert("Erro ao excluir usuário");
    }
  }

  async function handleUserReport() {
    try {
      const response = await api.get('/admin/report/user', {
        responseType: 'blob'
      })

      const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;"})

      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url

      link.setAttribute('download', 'relatorio-usuarios.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error(error)
    }
  }

  const { t } = useTranslation(undefined, { keyPrefix: "card" });
  return (
    <>
      <Header
        boxShadow
        mobileMenuActiveState={isMobileMenuVisible}
        toggleMobileMenu={setIsMobileMenuVisible}
        isSmallScreen={isSmallScreen}
        hamburgerIcon={true}
      />
      <main className={styles.mainContainer}>
        <section className={styles.sectionContainer}>
          <div className={styles.optionSelectedContainer}>
            <div className={styles.breadCrumbs}>
              <span>{t("account")}</span>
              <img src={rightArrow} />
              <span className={styles.optionSelected}>{t(`users`)}</span>
            </div>
          </div>

          <div className={styles.local}>
            <span> {t(`users`)}</span>
            <button onClick={handleUserReport} className={styles.buttonReport}>
              Gerar relatório
            </button>
          </div>
          <SelectWithLabel
            selectedValue={filterUser}
            setSelectedValue={setFilterUser}
            selectedValues={[
              {
                label: t("all"),
                value: "all",
              },
              {
                label: t("admin"),
                value: "Admin",
              },
              {
                label: t("client"),
                value: "Client",
              },
              {
                label: t("entrepreneur"),
                value: "Entrepeneur",
              },
            ]}
          />

          <div className={styles.wrapperProducts}>
            {usuarios.map((usuario: Usuariocard) => (
              <UsuarioItemAdmin
                key={usuario.id}
                usuario={usuario}
                deleteUser={deleteUser}
              />
            ))}
          </div>
        </section>

        {(!isSmallScreen || (isSmallScreen && isMobileMenuVisible)) && (
          <aside className={styles.asideContainer}>
            <SideBar
              isSmallScreen={isSmallScreen}
              closeMobileMenu={() => setIsMobileMenuVisible(false)}
            />
          </aside>
        )}
      </main>
      {!isSmallScreen && <Footer />}
    </>
  );
}

export default ListaUsers;
